import { render, staticRenderFns } from "./edit-candidate-remark.vue?vue&type=template&id=2a22f719&scoped=true"
import script from "./edit-candidate-remark.vue?vue&type=script&lang=ts"
export * from "./edit-candidate-remark.vue?vue&type=script&lang=ts"
import style0 from "./edit-candidate-remark.vue?vue&type=style&index=0&id=2a22f719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22f719",
  null
  
)

export default component.exports